var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "22", height: "20", viewBox: "0 0 22 20", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10.14 19.52C6.32 18.21.25 13.56.25 6.69.25 3.19 3.08.35 6.56.35c1.69 0 3.27.66 4.44 1.84A6.214 6.214 0 0 1 15.44.35c3.48 0 6.31 2.85 6.31 6.34 0 6.88-6.07 11.52-9.89 12.83-.25.09-.55.13-.86.13-.31 0-.61-.04-.86-.13zM1.75 6.69c0 6.83 6.57 10.63 8.88 11.42.18.06.57.06.75 0 2.3-.79 8.88-4.58 8.88-11.42 0-2.67-2.16-4.84-4.81-4.84-1.52 0-2.93.71-3.84 1.94-.28.38-.92.38-1.2 0a4.77 4.77 0 0 0-3.85-1.94c-2.65 0-4.81 2.17-4.81 4.84z", fill: "#292D32", fillRule: "evenodd" })
  );
});